<template>
  <div class="top">
    <el-dialog
      title="选择角色" :visible.sync="showDialog" width="30%" center
      append-to-body
    >
      <changeRole :visible.sync="showDialog"></changeRole>
    </el-dialog>
    <myTools></myTools>
    <div style="width: 180px; height: 100%; display: flex; align-items: center;">
      <img src="@/assets/img/logo.png" alt="考试云" style="width: 155px; height: 40px" @click="goIndex">
    </div>
    <el-menu ref="elMenu" mode="horizontal" @select="handleSelect">
      <el-menu-item index="examinee">我的考试</el-menu-item>
    </el-menu>

    <div style="margin-left: auto; height: 100%; display: flex; align-items: center;">
      <a href="javascript: void(0);" @click="toExam()" style="font-size: 16px;color: blue; text-decoration: underline !important;">进入考试管理中心</a>
      <div style="width: 15px;"></div>
      <el-image :src="userHead" style="width: 25px; height: 25px"></el-image>
      <div style="width: 5px;"></div>
      <label>{{yhmc}}</label>
      <div style="margin: 0 5px;">|</div>
      <span @click="loginOut" style="font-size: 16px;cursor: pointer;">
        退出登录
      </span>
    </div>

    <!-- <el-row style="padding-left: 180px">
      <el-col :span=16>
          <el-menu ref="elMenu" mode="horizontal" @select="handleSelect">
            <el-menu-item index="examinee">我的考试</el-menu-item>
          </el-menu>
      </el-col>
      <el-col :span=8 class="rightHeader" style="font-size: 16px;">
        <el-link :underline="false" type="primary" @click="toExam()" style="font-size: 16px;">进入考试管理中心</el-link>
        <div style="display: inline-flex;">
          <el-image :src="userHead" style="width: 25px; height: 25px"></el-image>
        </div>
        <label>{{yhmc}}</label>
        <span>|</span>
        <span>
          <a href="javascript:void(0)" @click="loginOut">退出登录</a>
        </span>
      </el-col>
    </el-row> -->
  </div>
</template>
<script>
import changeRole from '@/components/changeRole'
import myTools from '@/components/myTools'
import { loginByToken, loginOut } from '@/api/baseApi'
export default {
  data () {
    return {
      showDialog: false, // 显示角色切换窗
      yhmc: '',
      userHead: require('@/assets/img/defaultUserhead.png'),
      activeIndex: null
    }
  },
  components: {
    changeRole,
    myTools
  },
  methods: {
    setActiveIndex () {
      // 设置导航栏部分
      const url = this.$route.path
      if (RegExp(/^\/examinee[\s\S]*$/).test(url)) {
        this.activeIndex = 'examinee'
      } else if (url === '/') {
        this.activeIndex = 'examinee'
      }
      if (this.activeIndex) {
        // 更新默认导航栏
        this.$store.commit('changeDefaultActiveIndex', this.activeIndex)
      } else {
        // 选中上一次的那个导航栏
        const defaultActiveIndex = this.$store.state.defaultActiveIndex
        if (defaultActiveIndex) {
          this.activeIndex = defaultActiveIndex
        } else {
          this.activeIndex = 'examinee'
        }
      }
      this.$refs.elMenu.activeIndex = this.activeIndex
    },
    handleSelect (index) {
      // 还原选中状态
      this.$refs.elMenu.activeIndex = this.activeIndex
      // 更新默认导航栏
      this.$store.commit('changeDefaultActiveIndex', index)
      if (index === 'examinee') {
        this.$router.push({
          path: '/examinee/list'
        })
      }
    },
    goIndex () {
      this.$router.push({
        path: '/'
      })
    },
    loginOut () {
      loginOut().then(res => {
        this.$http.callback(res, () => {
          this.$router.push({
            path: '/login'
          })
        })
      })
    },
    toExam () {
      loginByToken(null).then(res => {
        this.$http.callback(res, () => {
          this.$store.commit('setUser', res.data.user)
          this.$store.commit('setToken', res.data.token)
          const xtbAqjsList = res.data.user.xtbAqjsList
          if (Array.isArray(xtbAqjsList) && xtbAqjsList.length > 1) {
            // 选择角色
            this.showDialog = true
          } else {
            this.$router.push({
              path: '/exam/list'
            })
          }
        })
      })
    }
  },
  mounted () {
    this.setActiveIndex()
    // 设置用户信息部分
    const user = this.$store.state.mobile.user
    if (user !== null) {
      this.yhmc = user.yhmc
      if (user.txdz) {
        this.userHead = user.txdz
      }
    }
  }
}
</script>
<style scoped>
  /* 修改导航栏样式 start */
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 5px solid #409EFF;
    color: #409EFF;
  }
  .el-menu--horizontal>.el-menu-item {
    color: black;
    font-size: 20px;
  }
  a {
    text-decoration: none;
    color: black;
  }
  #sysLogo:hover {
    cursor: pointer;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }
  .el-menu-item {
    font-weight: bold;
  }
  /* 修改导航栏样式 end */
  .top {
    height: 60px;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    background-color: #fff;
    padding: 0 1.5rem;
    width: 100%;
    /* box-sizing: border-box; */
    position: fixed;
    top: 0;
    z-index: 9;
  }
  .rightHeader {
    font-size: 18px;
    text-align: right;
    margin: 15px 0;
    display: inline-block;
    height: 30px;
    line-height: 30px
  }
  .rightHeader>span {
    margin : 3px;
  }
</style>
